import React, { useState, useEffect } from "react";

export default function ImageModal({ imagePath, className = "service-modal-image"}) {

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27 && open) {
        setOpen(false);
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [open]);

  return (
    <>
      <img
        onClick={() => setOpen(true)}
        src={imagePath}
        alt="img"
        className={className + " pointer-on-hover"}
      ></img>
      <div className={"service-modal " + (open ? "open" : "closed")}>
        <span onClick={() => setOpen(false)} className="service-modal-close">
          &times;
        </span>
        <img className="service-modal-content" src={imagePath} />
      </div>
    </>
  );
}
